import AdminApiService from "src/api/AdminApiService";
import BinAssemblySubmittalDTO from "src/models/BinAssemblySubmittalDTO";
import { deviceQueryKeys } from "src/components/BinDetails";
import { queryOptions } from "./v4QueryOptions/queryOptions";
import { binDBKeys } from "src/pages/binOverview/BinCommander";

export const getBinAssemblySubmittalQueryOptions = (binId: number | null | undefined) => queryOptions({
    queryKey: [binDBKeys.binInfo(binId!), "getBinAssemblySubmittalQuery"],
    queryFn: async (q) => {
        if(binId != null){
            return await AdminApiService.getBinAssemblySubmittal(binId, q.signal);
        }
        return {} as BinAssemblySubmittalDTO;
    },
    refetchOnWindowFocus: false,
});